export default [
    {
        // [0]
        key: "code",
        label: app.$i18n.t("Code"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "name",
        label: app.$i18n.t("Name"),
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "created_at",
        label: app.$i18n.t("Created at"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "created_at",
        label: app.$i18n.t("Created At"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "updated_at",
        label: app.$i18n.t("Updated At"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "id",
        label: app.$i18n.t("Actions"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
]